import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import HelperBusiness from '../../helper/Business';
import { withTranslation } from "react-i18next";
import lang from 'i18next';



class HeaderHealth extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      type: props.type ?? 'header',
      active: props.active ?? '',
    };
  }


  renderHabits() {
    if(HelperBusiness.getRoleIncl('trainer,admin')) {
      if(this.state.type === 'header') {
        return (
          <Link to={ROUTES.HABITS} className={this.state.active === 'habits' ? 'tab active' : 'tab'}>
            <p>{lang.t('nav:health.habits')}</p>
            <div className="bg"></div>
          </Link>
        )
      } else {
        return (
          <Link to={ROUTES.HABITS} className="item">
            <div className="bg"></div>
            <div className="text">{lang.t('nav:health.habits')}</div>
          </Link>
        )
      }
    }
  }


  render() {
    if(this.state.type === 'header') {
      return (
        <div>
          <Link to={ROUTES.NUTRITION} className={this.state.active === 'nutrition' ? 'tab active' : 'tab'}>
            <p>{lang.t('nav:health.nutrition')}</p>
            <div className="bg"></div>
          </Link>
          {this.renderHabits()}
        </div>
      )
    } else {
      return (
        <div>
          <Link to={ROUTES.NUTRITION} className="item">
            <div className="bg"></div>
            <div className="text">{lang.t('nav:health.nutrition')}</div>
          </Link>
          {this.renderHabits()}
        </div>
      )
    }
  }
}


export default withTranslation(['nav'])(HeaderHealth);